
//Time Complexity
//This implementation: O(V^2) | min heap implementation: O((V+E)logV)
//If the graph has a lot of edges, then V^2 will be close to E ==> this version
//If the graph is sparse, then E << V ==> min heap implementation 

// A função abaixo retorna o ID de todos os nós na ordem em que foram visitados
// e faz com que os nós apontem de volta para o nó anterior, 
// permitindo calcular o caminho mais curto retrocedendo a partir do nó final.
export function dijkstra(graph) {
  const visitedNodesIdInOrder = [];
  var tamVisited = 0
  const startNodeId = graph.startNode
  graph.list[startNodeId].distanceToStartNode = 0

  while(tamVisited < graph.vertices) {
    const closestNodeID = getClosestID(graph)
    graph.list[closestNodeID].isVisited = true
    tamVisited++
    visitedNodesIdInOrder.push(closestNodeID)
    if (closestNodeID === graph.finishNode) return visitedNodesIdInOrder;
    updateNeighbors(graph, closestNodeID)
  }
}

function getClosestID(graph) {
  var minDist = Infinity
  var closest = null
  for(let i = 0; i < graph.vertices; i++) {
    if(graph.list[i].isVisited === false && graph.list[i].distanceToStartNode < minDist) { 
      closest = i
      minDist = graph.list[i].distanceToStartNode
    }
  }
  return closest
}

function updateNeighbors(graph, closestNodeID) {
  for(let p = graph.list[closestNodeID].getHead(); p !== null; p = p.next) {
    var w = p.id
    var custo = p.distance
    if(graph.list[w].isVisited === false && 
      graph.list[w].distanceToStartNode > graph.list[closestNodeID].distanceToStartNode + custo) { 
        graph.list[w].distanceToStartNode = graph.list[closestNodeID].distanceToStartNode + custo
        graph.list[w].previousNodeId = closestNodeID 
    }
  }
}